import { Component, Input } from '@angular/core';
import { ProductGroup } from '@app/core/models/client';
import { NgStyle, NgClass } from '@angular/common';

@Component({
    selector: 'app-banner-preview',
    templateUrl: './banner-preview.component.html',
    styleUrls: ['./banner-preview.component.scss'],
    standalone: true,
    imports: [NgStyle, NgClass]
})
export class BannerPreviewComponent {
  @Input() productGroup: ProductGroup;
  @Input() viewProductInfo: boolean;
}
